import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/Loader';

// Casdoor configuration
const casdoorConfig = {
  serverUrl: import.meta.env.VITE_CASDOOR_URL || '',
  clientId: import.meta.env.VITE_CASDOOR_CLIENT_ID || '',
  clientSecret: '', // Never expose in frontend! This is for demo only
  appName: import.meta.env.VITE_CASDOOR_APP_NAME || '',
  organizationName: import.meta.env.VITE_CASDOOR_ORG_NAME || '',
};

export const CasdoorCallback: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get code and state from URL
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');

        if (!code) {
          setError('No authorization code received');
          return;
        }

        console.log('Casdoor: Received authorization code:', code);
        console.log('Casdoor: State:', state);

        // For now, we'll use a simplified approach
        // In production, you should exchange code for token via your backend
        
        // Store a temporary flag
        localStorage.setItem('casdoorAuthCode', code);
        localStorage.setItem('casdoorAuthState', state || '');
        
        // Redirect to home - the main context will handle the rest
        navigate('/', { replace: true });
      } catch (error) {
        console.error('Callback handling failed:', error);
        setError('Login failed: ' + (error instanceof Error ? error.message : 'Unknown error'));
      }
    };

    handleCallback();
  }, [navigate]);

  if (error) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: '1rem',
      }}>
        <h1>Login Error</h1>
        <p style={{ color: 'red' }}>{error}</p>
        <button
          onClick={() => navigate('/')}
          style={{
            padding: '0.5rem 2rem',
            fontSize: '1rem',
            cursor: 'pointer',
          }}
        >
          Try Again
        </button>
      </div>
    );
  }

  return <Loader fullscreen source="CasdoorCallback" />;
};

